import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';

const quoteRejectedIssueId = buildIssueId({
  area: 'quote',
  type: 'rejected',
});

export function quoteUpdateTriggered(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  deleteIssue(state, quoteRejectedIssueId);
  state.isUpdating = true;
}

export function quoteUpdateSucceeded(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  state.isUpdating = false;
}

export function quoteUpdateFailed(state: WritableDraft<QuoteBuilderStateType>) {
  state.isUpdating = false;

  upsertIssue(state, quoteRejectedIssueId, {
    title: 'Failed to Update Quote',
    description: 'Quote could not be updated in the database',
    area: 'quote',
    severity: 'error',
    type: 'rejected',
    action: {
      type: 'unrecoverable',
    },
  });
}
